/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
  "use strict";

  angular
    .module("ROGER")

    //
    .controller("SalesOrderLineEditController", [
      "$scope",
      "$q",
      "$http",
      "$sessionStorage",
      "$uibModal",
      "$well",
      "$translate",
      "$addressLookup",
      "$messageBox",
      "$routeParams",
      "customerService",
      "$oidc",
      function (
        $scope,
        $q,
        $http,
        $sessionStorage,
        $uibModal,
        $well,
        $translate,
        $addressLookup,
        $messageBox,
        $routeParams,
        customerService,
        oidc
      ) {
        $scope.$storage = $sessionStorage;

        $scope.retailers = [];
        $scope.salesOrderTypes = [];
        $scope.countries = [];
        $scope.fleetUsage = [];
        $scope.lastSalesOrderNumber = "";
        $scope.campaignNull = {};
        $scope.campaignUpdated = false;
        let validateOrderTypeBonus = true;

        $scope.salesOrder = {
          Lines: [
            {
              TypeId: "",
              CampaignId: 0,
              Customer: {
                Age: "",
                BirthYear: "",
              },
            },
          ],
        };

        $scope.$watch("$storage.retailer", function (newValue, oldValue) {
          if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
            $scope.refresh();
          }
        });

        // Sales Order
        $scope.loadSalesOrder = function (id) {
          return $http
            .get(
              "/api/retailer/" +
                $scope.$storage.retailer.Id +
                "/sales-order/line/" +
                id,
              {
                headers: {
                  Authorization:
                    oidc.current.token_type + " " + oidc.current.access_token,
                },
              }
            )
            .then(function (response) {
              var order = response.data;
              if (order.Lines[0].CampaignId == null) {
                order.Lines[0].CampaignId = 0;
              }
              $scope.salesOrder = order;
              $scope.typeId = $scope.salesOrder.Lines[0].TypeId;
              $scope.setCustomerSearchInfo();
            });
        };

        // Retailers
        $scope.loadRetailers = function () {
          return $http
            .get("/api/retailer", {
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              $scope.retailers = response.data;
            });
        };

        // Sales order types
        $scope.loadSalesOrderTypes = function () {
          return $http
            .get("/api/sales-order-type", {
              params: {
                retailerId: $scope.$storage.retailer.Id,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              $scope.salesOrderTypes = response.data;
            });
        };

        $scope.getSalesOrderTypes = function () {
          return $scope.salesOrderTypes;
        };

        function validateOrderType(oldValue, newValue) {
          if (validateOrderTypeBonus && oldValue !== "") {
            return $scope
              .changeOrderTypeConfirm(
                oldValue,
                newValue,
                $scope.salesOrder.Lines[0].IsBonusCar
              )
              .then(
                function () {
                  return $q.resolve();
                },
                function () {
                  $scope.salesOrder.Lines[0].TypeId = oldValue;
                  validateOrderTypeBonus = false;
                  return $q.reject();
                }
              );
          } else {
            validateOrderTypeBonus = true;
            return $q.resolve();
          }
        }

                $scope.$watch("salesOrder.Lines[0].TypeId", function (newValue, oldValue) {
                    if (newValue !== oldValue && oldValue !== null) {
                        validateOrderType(oldValue, newValue)
                            .then(function () {
                                if (newValue === 5 || newValue === 6 || newValue === 8) {
                                    return $scope
                                        .loadFleets()
                                        .then(function () {
                                            if ($scope.fleets.length === 0) {
                                                $uibModal.open({
                                                    template: require("../Shopping/ShoppingCartFleetNotAvailable.html"),
                                                    controller: "ShoppingCartFleetNotAvailableController"
                                                });
                                                $scope.salesOrder.Lines[0].TypeId = oldValue;
                                                validateOrderTypeBonus = false;
                                                return $q.reject();
                                            } else {
                                                if (oldValue !== "") {
                                                    $scope.resetFleet();
                                                }
                                                return $q.resolve();
                                            }
                                        }, function (data) {
                                            return $q.reject();
                                        });
                                } else if (oldValue === 5 || oldValue === 6 || oldValue === 8) {
                                    $scope.resetFleet();
                                    return $q.resolve();
                                }
                                return $q.resolve();
                            }, function (data) {
                                return $q.reject();
                            })
                            .then(function () {
                                var promises = [];
                                promises.push($scope.loadCampaigns());
                                if (oldValue !== "") {
                                    promises.push($scope.resetCampaign());
                                }

                    promises.push($scope.loadPostProductionOptions());

                    return $q.all(promises);
                  },
                  function (data) {
                    return $q.reject();
                  }
                );
            }
          }
        );

        // Customer
        $scope.loadCustomer = function (customer) {
          return $scope.customerService
            .get($scope.$storage.retailer.Id, customer.Id)
            .then(function (cust) {
              $scope.salesOrder.Lines[0].Customer = cust;
            });
        };

        $scope.customerService = customerService;

        $scope.setEmptyCustomer = function () {
          $scope.salesOrder.Lines[0].Customer = {
            Id: 0,
            Address: {
              CountryId: $scope.$storage.retailer.CountryId,
            },
          };
        };

        $scope.setCustomerSearchInfo = function () {
          if (
            typeof $scope.salesOrder.Lines[0].Customer != "undefined" &&
            $scope.salesOrder.Lines[0].Customer != null
          ) {
            $scope.customerSearchInfo = (
              $scope.salesOrder.Lines[0].Customer.Title +
              " " +
              $scope.salesOrder.Lines[0].Customer.FirstName +
              " " +
              $scope.salesOrder.Lines[0].Customer.LastName
            ).replace("  ", " ");
          } else {
            $scope.customerSearchInfo = null;
            $scope.salesOrder.Lines[0].Customer = {
              Address: {
                CountryId: $scope.$storage.retailer.CountryId,
              },
            };
          }
        };

        $scope.customerOnSelect = function (customer) {
          if (typeof customer != "undefined" && customer != null) {
            if (customer.Id > 0) {
              $scope.loadCustomer(customer);
            } else {
              $scope.setEmptyCustomer();
            }
          } else {
            $scope.setEmptyCustomer();
          }
        };

        $scope.customerCancelEditMode = function () {
          $scope.customerSearchInfo = null;
          $scope.salesOrder.Lines[0].Customer = {
            Address: {
              CountryId: $scope.$storage.retailer.CountryId,
            },
          };
        };

        $scope.customerIsInLookupMode = function () {
          return (
            typeof $scope.salesOrder.Lines[0].Customer == "undefined" ||
            $scope.salesOrder.Lines[0].Customer == null ||
            typeof $scope.salesOrder.Lines[0].Customer.Id == "undefined" ||
            $scope.salesOrder.Lines[0].Customer.Id == null
          );
        };

        $scope.customerIsInEditMode = function () {
          return !$scope.customerIsInLookupMode();
        };

        // Customer address
        $scope.addressLookup = function (searchText) {
          return $addressLookup.lookup(searchText).then(
            function (result) {
              return result;
            },
            function (error) {
              return error;
            }
          );
        };

        $scope.addressOnSelect = function (address) {
          if (typeof address != "undefined" && address != null) {
            $addressLookup.detail(address.place_id).then(function (result) {
              var house = "";
              var house2 = "";
              var street = "";
              var city = "";
              var postCode = "";
              var country = "";
              for (
                var index = 0;
                index < result.address_components.length;
                index++
              ) {
                if (result.address_components[index].types[0] === "premise") {
                  house = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "street_number"
                ) {
                  house2 = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "route"
                ) {
                  street = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "locality"
                ) {
                  city = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "postal_code"
                ) {
                  postCode = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "country"
                ) {
                  country = result.address_components[index].short_name;
                }
              }
              $scope.salesOrder.Lines[0].Customer.Address.Street = street;
              if (house != null && house.trim() !== "") {
                $scope.salesOrder.Lines[0].Customer.Address.Street =
                  $scope.salesOrder.Lines[0].Customer.Address.Street +
                  " " +
                  house;
              }
              if (house2 != null && house2.trim() !== "") {
                if (house != null && house.trim() !== "") {
                  $scope.salesOrder.Lines[0].Customer.Address.Street =
                    $scope.salesOrder.Lines[0].Customer.Address.Street +
                    "/" +
                    house2;
                } else {
                  $scope.salesOrder.Lines[0].Customer.Address.Street =
                    $scope.salesOrder.Lines[0].Customer.Address.Street +
                    " " +
                    house2;
                }
              }
              $scope.salesOrder.Lines[0].Customer.Address.City = city;
              $scope.salesOrder.Lines[0].Customer.Address.PostCode = postCode;
              $scope.salesOrder.Lines[0].Customer.Address.CountryId =
                $scope.getCountryIdByIsoShort(country);
            });
          }
        };

        // Campaign
        $scope.loadCampaign = function (campaignId) {
          return $http
            .get("/api/campaign/" + campaignId, {
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              return response.data;
            });
        };

        $scope.loadCampaigns = function () {
          return $http
            .get("/api/campaign", {
              params: {
                retailerId: $scope.$storage.retailer.Id,
                modelColorId: $scope.salesOrder.Lines[0].ModelColorId,
                salesOrderTypeId: $scope.salesOrder.Lines[0].TypeId,
                fleetModelId: $scope.salesOrder.Lines[0].FleetModelId,
                salesOrderLineId: $scope.salesOrder.Lines[0].Id,
                unitId: $scope.salesOrder.Lines[0].UnitId,
                solFromResId: $scope.salesOrder.Lines[0].FromResId,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(
              function (response) {
                $scope.campaigns = response.data;
                $translate("CampaignNone").then(
                  function (translation) {
                    $scope.campaigns.splice(0, 0, {
                      Id: 0,
                      Name: translation,
                      Description: "",
                    });
                  },
                  function () {
                    $scope.campaigns.splice(0, 0, {
                      Id: 0,
                      Name: "None",
                      Description: "",
                    });
                  }
                );
                if ($scope.salesOrder.Lines[0].CampaignId != 0) {
                  if (
                    !$scope.campaigns.some(function (campaign) {
                      return (
                        Number(campaign.Id) ===
                        Number($scope.salesOrder.Lines[0].CampaignId)
                      );
                    })
                  ) {
                    $scope
                      .loadCampaign($scope.salesOrder.Lines[0].CampaignId)
                      .then(function (campaign) {
                        $scope.campaigns.push(campaign);
                      });
                  }
                }
              },
              function () {}
            );
        };

        //$scope.$watch("salesOrder.Lines[0].CampaignId", function (newValue, oldValue) {
        //    if (newValue !== oldValue) {
        //        $scope.loadPostProductionOptions();
        //    }
        //});

        $scope.resetCampaign = function () {
          $scope.salesOrder.Lines[0].CampaignId = 0;
        };

        $scope.onCampaignChanged = function () {
          $scope.campaignUpdated = true;
          $scope.loadPostProductionOptions();
        };

        $scope.onFleetModelChanged = function () {
          $scope.loadCampaigns();
          $scope.resetCampaign();

          $scope.loadPostProductionOptions();
        };

        $scope.resetFleet = function () {
          $scope.salesOrder.Lines[0].FleetModelId = null;
        };

        // Post production options
        $scope.loadPostProductionOptions = function () {
          return $http
            .get("/api/post-production-option", {
              params: {
                retailerId: $scope.$storage.retailer.Id,
                modelColorId: $scope.salesOrder.Lines[0].ModelColorId,
                salesOrderTypeId: $scope.salesOrder.Lines[0].TypeId,
                campaignId: $scope.salesOrder.Lines[0].CampaignId,
                fleetModelId: $scope.salesOrder.Lines[0].FleetModelId,
                salesOrderLineId: $scope.salesOrder.Lines[0].Id,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(
              function (response) {
                $scope.postProductionOptions = response.data;
                for (var i = 0; i < $scope.postProductionOptions.length; i++) {
                  $scope.postProductionOptions[i].IsChecked =
                    $scope.postProductionOptions[i].IsMandatory ||
                    $scope.postProductionOptions[i].IsFromNewCampaign ||
                    ($scope.salesOrder.Lines[0].PostProductionOptionsIds !=
                      null &&
                      $scope.salesOrder.Lines[0].PostProductionOptionsIds.indexOf(
                        $scope.postProductionOptions[i].Id
                      ) > -1);
                }
              },
              function () {}
            );
        };

        // Fleets
        $scope.loadFleet = function (fleetModelId) {
          return $http
            .get("/api/fleet/fleet-model/" + fleetModelId, {
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(
              function (response) {
                return response.data;
              },
              function () {}
            );
        };

        $scope.loadFleets = function () {
          return $http
            .get("/api/fleet", {
              params: {
                salesOrderLineId: $scope.salesOrder.Lines[0].Id,
                retailerId: $scope.$storage.retailer.Id,
                modelColorId: $scope.salesOrder.Lines[0].ModelColorId,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(
              function (response) {
                $scope.fleets = response.data;
              },
              function () {}
            );
        };

        //$scope.$watch("salesOrder.Lines[0].FleetModelId", function (newValue, oldValue) {
        //    if (newValue !== oldValue) {
        //        $scope.loadCampaigns();
        //    }
        //});

        // Countries
        $scope.loadCountries = function () {
          return $http
            .get("/api/country", {
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(
              function (response) {
                $scope.countries = response.data;
              },
              function () {}
            );
        };

        $scope.isCcp = function (orderTypeId) {
          if (!$scope.salesOrderTypes) return false;

          for (var i = 0; i < $scope.salesOrderTypes.length; i++) {
            if (
              orderTypeId === $scope.salesOrderTypes[i].Id &&
              $scope.salesOrderTypes[i].Code === "CCP"
            ) {
              return true;
            }
          }
          return false;
        };

        $scope.isExp = function (orderTypeId) {
          if (!$scope.salesOrderTypes) return false;

          for (var i = 0; i < $scope.salesOrderTypes.length; i++) {
            if (
              orderTypeId === $scope.salesOrderTypes[i].Id &&
              $scope.salesOrderTypes[i].Code === "EXP"
            ) {
              return true;
            }
          }
          return false;
        };

        $scope.isHungary = function (countryId) {
          if (!$scope.countries) return false;

          for (var i = 0; i < $scope.countries.length; i++) {
            if (
              $scope.countries[i].Id === countryId &&
              $scope.countries[i].IsoShort === "HU"
            ) {
              return true;
            }
          }
          return false;
        };

        $scope.isHungaryCcpOrExp = function (countryId, orderTypeId) {
          return (
            $scope.isHungary(countryId) &&
            ($scope.isCcp(orderTypeId) || $scope.isExp(orderTypeId))
          );
        };

        $scope.getCountryIdByIsoShort = function (isoShort) {
          for (var index = 0; index < $scope.countries.length; index++) {
            if ($scope.countries[index].IsoShort === isoShort) {
              return $scope.countries[index].Id;
            }
          }
          return null;
        };

        // Survey
        $scope.brandModelLineLookup = function (searchText) {
          return $http
            .get("api/sales-survey/brand-model-line/search", {
              params: {
                searchText: searchText,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              return response.data;
            });
        };

        // Update sales order
        $scope.getSalesOrder = function () {
          var result = $scope.salesOrder;

          result.Lines[0].Order = 1;

          if (result.Lines[0].Customer.Id <= 0) {
            result.Lines[0].Customer.Id = null;
          }

          if (result.Lines[0].CampaignId === 0) {
            result.Lines[0].CampaignId = null;
          }

          if (
            !$scope.isHungaryCcpOrExp(
              result.Lines[0].CustomerCountryId,
              result.Lines[0].TypeId
            )
          ) {
            result.Lines[0].PostCode = "";
          }

          result.Lines[0].PostProductionOptionsIds = [];
          for (
            var index = 0;
            index < $scope.postProductionOptions.length;
            index++
          ) {
            if ($scope.postProductionOptions[index].IsChecked) {
              result.Lines[0].PostProductionOptionsIds.push(
                $scope.postProductionOptions[index].Id
              );
            }
          }
          return result;
        };

        $scope.changeOrderTypeConfirm = function (
          oldTypeId,
          newTypeId,
          isBonusCar
        ) {
          if (
            isBonusCar &&
            (oldTypeId === 2 || oldTypeId === 7) &&
            newTypeId != 2 &&
            newTypeId != 7
          ) {
            return $messageBox.showConfirm(
              "ChangeOrderType.Title",
              "ChangeOrderType.CreateBonus",
              "ChangeOrderType.Action"
            ).result;
          } else if (
            isBonusCar &&
            oldTypeId != 2 &&
            oldTypeId != 7 &&
            (newTypeId === 2 || newTypeId === 7)
          ) {
            return $messageBox.showConfirm(
              "ChangeOrderType.Title",
              "ChangeOrderType.LoseBonus",
              "ChangeOrderType.Action"
            ).result;
          }

          return $q.resolve();
        };

        $scope.updateSalesOrderRequest = function () {
          return $http.put(
            "/api/retailer/" + $scope.$storage.retailer.Id + "/sales-order",
            $scope.getSalesOrder(),
            {
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            }
          );
        };

        $scope.updateSalesOrder = function () {
          return $messageBox
            .showConfirm(
              "EditSalesOrder",
              "EditSalesOrderConfirmation",
              "EditSalesOrder"
            )
            .result.then(
              function () {
                return $scope.updateSalesOrderRequest();
              },
              function () {
                $scope.$digest();
                return $q.reject();
              }
            )
            .then(
              function () {
                window.history.back();
              },
              function () {}
            );
        };

        if (
          $scope.$storage.retailer !== null &&
          $scope.$storage.retailer.Id > 0
        ) {
          $scope.loadRetailers();
          $scope.loadCountries();
          $scope.loadSalesOrderTypes();

          //
          $scope.loadSalesOrder($routeParams.id).then(function () {
            return $scope.loadFleets();
          });
        }
      },
    ]);
})();
